export const SEVERITY = {
  critical: { color: "#FF3B30", label: "CRITICAL" },
  high: { color: "#FF9500", label: "HIGH" },
  medium: { color: "#FFCC00", label: "MEDIUM" },
  low: { color: "#00F0FF", label: "LOW" },
};

export function SeverityBadge({ level }) {
  const s = SEVERITY[level] || SEVERITY.low;
  return (
    <span
      data-testid={`severity-badge-${level}`}
      className="inline-flex items-center gap-1.5 px-2 py-0.5 text-[10px] uppercase tracking-[0.15em] font-mono font-bold rounded-none border"
      style={{ color: s.color, borderColor: s.color, backgroundColor: `${s.color}1A` }}
    >
      <span className="w-1.5 h-1.5" style={{ backgroundColor: s.color }} />
      {s.label}
    </span>
  );
}
